import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import MultiViewCalendarProps from './MultiViewCalendarProps'

import Messages from './Messages'
import Month from './Month'
import Range from './Range'

export default {
    props: MultiViewCalendarProps,
    mixins: [
        KendoBaseComponent, 
        Messages, 
        Month, 
        Range
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoMultiViewCalendar(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMultiViewCalendar()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoMultiViewCalendar/KendoMultiViewCalendarMixin.js